import { useQuery } from '@tanstack/react-query';
import { userService, reviewService } from '../../services';

export const CREATOR_PROFILE_QUERY_KEY = 'creatorProfile';

export function useCreatorProfile(creatorId, enabled = true) {
  console.log('[useCreatorProfile] Hook called:', { creatorId, enabled, isEnabled: !!creatorId && enabled });
  
  const query = useQuery({
    queryKey: [CREATOR_PROFILE_QUERY_KEY, creatorId],
    queryFn: async () => {
      console.log('[useCreatorProfile] Fetching profile for:', creatorId);
      try {
        const [profile, reviews] = await Promise.all([
          userService.getUserProfile(creatorId),
          reviewService.getCreatorReviews(creatorId),
        ]);
        console.log('[useCreatorProfile] Data fetched successfully:', { profile, reviewsCount: reviews.length });
        return { profile, reviews };
      } catch (error) {
        console.error('[useCreatorProfile] Error fetching:', error);
        throw error;
      }
    },
    enabled: !!creatorId && enabled,
  });
  
  console.log('[useCreatorProfile] Query state:', {
    isLoading: query.isLoading,
    isError: query.isError,
    isSuccess: query.isSuccess,
    hasData: !!query.data,
    error: query.error
  });
  
  return query;
}
